<mat-toolbar class="ca-toolbar justify-between">
    <div class="flex items-center">
        <div class="hidden sm:flex gap-1 app-name">
            <img class="app-logo cursor-pointer" src="/assets/images/vi-logo.svg" alt="Viessmann" routerLink="/projects" />
            <span>･</span>
            <span data-testid="app-title">{{ 'COMMON.APP_NAME' | translate }}</span>
        </div>
    </div>
    @if (settingsStore.state$ | async; as state) {
        <div class="flex items-center">
            @if (isAuthenticated | async) {
                <vp-country-language-switcher></vp-country-language-switcher>
            }
            <vih-support-link data-testid="global-login-support-link"></vih-support-link>
            <vih-app-switcher
                data-testid="global-login-app-switcher"
                [appId]="environmentService.appId"
                [userId]="$any(authStore.userId$ | async)"
                [lang]="state.locale | languageCode"
            ></vih-app-switcher>
            <vih-login
                data-testid="global-login-button"
                [appManagesAuthentication]="true"
                [authenticated]="isAuthenticated"
                [lang]="state.locale | languageCode"
                (logoutEvent)="logout()"
            ></vih-login>
        </div>
    }
</mat-toolbar>
